import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../../urls";
//axios
import axios from "../../utilies/axios";
//_________________________________________________

// GET =>  All ALL CLIENTS SERVICE
export const getClientsService = createAsyncThunk(
  "clients/getClientsService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.clientURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST =>  CREATE CLIENT SERVICE
export const createClientService = createAsyncThunk(
  "clients/createClientService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.clientURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// DELETE =>  DELETE CLIENT SERVICE
export const deleteClientService = createAsyncThunk(
  "clients/deleteClientService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.clientURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// UPDATE =>  UPDATE CLIENT SERVICE
export const updateClientService = createAsyncThunk(
  "clients/updateClientService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.clientsURL}${params?.id}`,
        params.formData
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  GET CLIENT BY ID SERVICE
export const getClientByIdService = createAsyncThunk(
  "clients/getClientByIdService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.clientsURL}${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
